module.exports = __webpack_public_path__ + "img/nurse-providing-advice.5dc0ed13.jpg";